import axios from 'axios';
import shuffle from 'lodash/shuffle'; 

import CacheService from '../../cache-service';

// const conf = {
//   adTitle: 'Angular Academy',
//   imgUrl: '/images/partners/angular-academy-banner.png',
//   redirectUrl: 'https://angular-academy.com?utm_source=dormoshe&utm_medium=banner'
// };

class AdDataService extends CacheService {
  lastPage = '';
  lastPageShuffledConf = null;
  numOfRepeatsLastPage = 0;

  getConfByTags(adsByPageTags, relevantTags) {
    for (let relevantTag of relevantTags) {
      if (adsByPageTags[relevantTag]) return adsByPageTags[relevantTag];
    }
    return;
  }

  getAdConf(smartAdProps, isAdExistCheck = false, limitNumOfAdsPerSamePage = 2, forceShowAd = false) {
    // const pageID = (document.location.pathname || '').replace('/', '').split('?').join('-').split(':').join('').split('/').join('_');
    const pageID = document.location.pathname;

    return this.getCachedData(`/api/das`).then((conf) => {
      try {
        // null (place your ad here), empty (no ad)
        if (!conf) {
          if (isAdExistCheck) return conf;

          if (this.lastPage !== pageID) {
            this.lastPage = pageID;
            return conf;
          }
          
          // same page
          return {
            empty: true
          };
        }

        if (conf.empty) return conf;
        
        const adsByPage = conf;
        const {LMKHTML, onSaleHTML} = conf;
        const adAdditionals = { LMKHTML, onSaleHTML };
        const tags = smartAdProps && smartAdProps.tags;
        const pageConfKey = Object.keys(adsByPage).find(pageKey => {
          if (!pageID.startsWith(pageKey)) return false;

          return true;
        });
        
        if (!isAdExistCheck && this.lastPage === pageID) {
          this.numOfRepeatsLastPage++;
          if (!forceShowAd && this.numOfRepeatsLastPage > limitNumOfAdsPerSamePage) {
            // for the 3rd+ time dont show no ad partner 
            return { empty: true };
          }

          // because we already increment it (the minus 1)
          const selectedAd = this.lastPageShuffledConf.slice(this.numOfRepeatsLastPage - 1)[0] || shuffle(this.lastPageShuffledConf)[0];
          return selectedAd ? {
            ...adAdditionals,
            ...selectedAd,
          } : selectedAd;
        }
        
        // new page
        let pageConf;
        if (pageConfKey) {
          pageConf = adsByPage[pageConfKey];
        } 
        else if (tags && adsByPage.tags) {
          pageConf = this.getConfByTags(adsByPage.tags, smartAdProps.tags);
        }

        pageConf = pageConf || adsByPage.fallback
        
        if (isAdExistCheck) {
          return pageConf[0] ? {
            ...adAdditionals,
            ...pageConf[0]
          } : pageConf[0];
        }

        this.lastPage = pageID;
        this.numOfRepeatsLastPage = 1;
        this.lastPageShuffledConf = shuffle(pageConf);
        return this.lastPageShuffledConf[0] ? {
            ...adAdditionals,
            ...this.lastPageShuffledConf[0]
        } : this.lastPageShuffledConf[0];
      }
      catch(err) {
        return null;
      }        
    });
  }

  adLetMeKnow(email, udemyId, tagStr, adTitle) {
    return axios.post('/api/das/lmk', {
      email, udemyId, tagStr, adTitle
    }).then(res => res.data).catch({});
  }
}

const adDataService = new AdDataService();
export default adDataService;